import { gql } from '@apollo/client';

export const GET_PARTNERS = gql`
    query getPartners {
        partners {
            id
            name
            displayName
            logoPath
            options
        }
    }
`;
